module.exports = __webpack_public_path__ + "9fa6000dfa950929c2b6bac4a9e34e79.svg";